import React from 'react';
import { Navigate } from 'react-router-dom';
import { redirectUnlessInventory } from '../../utils/moduleAccess';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import SharedDataTable from '../../_components/Shared/SharedDataTable';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import UploadFilesService from '../../_services/upload-files.service';
import { handleFocusInScrollField, INVENTORY_MODAL_BODY_SCROLL_STYLE } from './invKeyboardScroll';
import MasterPartNoInput from '../../_components/MasterPartNoInput';
import { isPartNoCreateEnabled, MASTER_PART_NO_VALIDATION_STATUS } from '../../utils/masterPartNoValidation';
import ObsoletePartNoCell from '../../_components/ObsoletePartNoCell';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

let perPage = 30;

class MasterFinishedGoods extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            partNo: '',
            partDescription: '',
            packagingType: '',
            packagingTypeOther: '',
            packagingQuantity: 0,
            MOQ: '',
            UoM: '',
            UoMOther: '',
            shippingDock: '',
            shippingDockOther: '',
            incoterms: '',
            incotermsOther: '',
            customer: '',
            country: '',
            countryOther: '',
            specialRequirement: '',
            sellingPrice: 0,
            sellingPriceCurrency: 'MYR',
            sellingPriceRate: 1.0,
            editingRate: false,
            shippingMode: '',
            remarks: '',
            photoUrl: '',
            selectedPhoto: null,
            photoPreview: null,
            products: [],
            body: [],
            pageCount: 0,
            keyword: '',
            modalShow: false,
            newMode: false,
            offset: 0,
            locations: [],
            // Default FG warehouse location code for this finished good
            defaultLocationCode: '',
            countries: ['Malaysia', 'Singapore', 'Thailand', 'Indonesia', 'Vietnam', 'Philippines', 'China', 'India', 'Japan', 'South Korea', 'United States', 'United Kingdom', 'Germany', 'France', 'Australia', 'Others'],
            currencySettings: {
                defaultCurrency: 'MYR',
                currencies: []
            },
            bomModalShow: false,
            bomModalLoading: false,
            bomModalError: '',
            bomModalRows: [],
            bomModalPartNo: '',
            bomModalMasterDataId: null,
            bomModalUoms: [],
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
        };

        this.columns = [
            {
                name: 'Actions',
                cell: (row, rowIndex) => (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap', minWidth: '170px', paddingRight: '10px' }}>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => this.onClickProductSelected(null, row, rowIndex)}
                        >
                            Edit
                        </button>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(null, row, rowIndex)}
                        >
                            Delete
                        </button>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '170px',
                minWidth: '170px',
            },
            {
                name: 'Customer',
                selector: row => row.customer || '',
                sortable: true,
                maxWidth: '125px',
                width: '125px',
            },
            {
                name: 'Part Number',
                selector: row => row.partNo || '',
                cell: row => <ObsoletePartNoCell value={row.partNo || ''} isObsolete={row.isPartObsolete} />,
                sortable: true,
                maxWidth: '200px',
                width: '200px',
            },
            {
                name: 'BOM',
                cell: (row) => (
                    <div style={{ whiteSpace: 'nowrap', fontSize: '13px' }}>
                        {row.bomMasterDataId ? (
                            <button
                                type="button"
                                className="btn btn-sm btn-default"
                                style={{ padding: '4px 10px' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.openBomModal(row);
                                }}
                            >
                                View BOM
                            </button>
                        ) : (
                            <span style={{ color: '#888' }}>—</span>
                        )}
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '110px',
                minWidth: '110px',
            },
            {
                name: 'Part Description',
                selector: row => row.partDescription || '',
                sortable: true,
                maxWidth: '250px',
                width: '250px',
            },
            {
                name: 'Packaging Type',
                selector: row => {
                    if ((row.packagingType || '') === 'others') {
                        return row.packagingTypeOther || 'others';
                    }
                    return row.packagingType || '';
                },
                sortable: true,
                maxWidth: '180px',
                width: '180px',
            },
            {
                name: 'Packaging Quantity',
                selector: row => row.packagingQuantity || 0,
                sortable: true,
                maxWidth: '170px',
                width: '170px',
            },
            {
                name: 'Default Location',
                selector: row => row.defaultLocationCode || '',
                sortable: true,
                maxWidth: '200px',
                width: '200px',
            },
            {
                name: 'Shipping Dock',
                selector: row => {
                    if ((row.shippingDock || '') === 'others') {
                        return row.shippingDockOther || 'others';
                    }
                    return row.shippingDock || '';
                },
                sortable: true,
                maxWidth: '170px',
                width: '170px',
            }
        ];
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.fetchFGWarehouseLocations();
        this.fetchCurrencySettings();
        this.buildHtmlTable();
    }

    fetchFGWarehouseLocations() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            fetch(`${config.apiUrl}/getFGWarehouseLocations?company=${user.accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(locations => {
                    if (locations && Array.isArray(locations)) {
                        this.setState((prev) => {
                            const next = { locations };
                            if (locations.length === 1 && locations[0].locationCode && !prev.defaultLocationCode) {
                                next.defaultLocationCode = locations[0].locationCode;
                            }
                            return next;
                        });
                    } else {
                        this.setState({ locations: [] });
                    }
                })
                .catch(error => {
                    console.error('Error fetching FG warehouse locations:', error);
                    this.setState({ locations: [] });
                });
        }
    }

    fetchCurrencySettings = () => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            fetch(`${config.apiUrl}/getCurrencySettings?company=${user.accountId}`, requestOptions)
                .then((response) => {
                    if (response.status === 404) {
                        // Use defaults if settings don't exist
                        return {
                            defaultCurrency: 'MYR',
                            currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                        };
                    }
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.text().then(text => {
                        if (!text || text.trim() === '') {
                            return {
                                defaultCurrency: 'MYR',
                                currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                            };
                        }
                        try {
                            return JSON.parse(text);
                        } catch (e) {
                            console.error('Error parsing JSON:', e);
                            return {
                                defaultCurrency: 'MYR',
                                currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                            };
                        }
                    });
                })
                .then(data => {
                    if (data) {
                        this.setState({
                            currencySettings: data,
                            sellingPriceCurrency: data.defaultCurrency || 'MYR',
                            sellingPriceRate: this.getCurrencyRate(data.defaultCurrency || 'MYR', data.currencies || [])
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching currency settings:', error);
                    // Use defaults on error
                    this.setState({
                        currencySettings: {
                            defaultCurrency: 'MYR',
                            currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                        },
                        sellingPriceCurrency: 'MYR',
                        sellingPriceRate: 1.0
                    });
                });
        }
    }

    getCurrencyRate = (code, currencies) => {
        const currency = currencies.find(c => c.code === code);
        return currency ? currency.rate : 1.0;
    }

    calculateConvertedPrice = (price, fromCurrency, toCurrency, currencies) => {
        if (!price || price === 0) return 0;
        const fromRate = this.getCurrencyRate(fromCurrency, currencies);
        const toRate = this.getCurrencyRate(toCurrency, currencies);
        if (fromRate === 0) return 0;
        return (price * toRate) / fromRate;
    }

    exportExcel() {
        utils.tableToExcel('master-finished-goods-export-table', 'masterfinishedgoods', 'MasterFinishedGoods_' + moment().format('YYYYMMDD') + '.xls');
    }

    flattenBomTree(items, parentRowNo = '') {
        const out = [];
        if (!items || !Array.isArray(items)) return out;
        items.forEach((item, index) => {
            const rowNo = parentRowNo ? `${parentRowNo}.${index + 1}` : `${index + 1}`;
            const ch = item.children;
            out.push({
                rowNo,
                material: item.material || '',
                materialDesc: item.materialDesc || '',
                code: item.code || '',
                color: item.color || '',
                usage: item.usage,
                per: item.per,
                where_use: item.where_use || '',
                supplier: item.supplier || '',
                uom: item.uom,
            });
            if (ch && ch.length) {
                out.push(...this.flattenBomTree(ch, rowNo));
            }
        });
        return out;
    }

    openBomModal = (row) => {
        if (!row || !row.bomMasterDataId) return;
        const masterDataId = row.bomMasterDataId;
        const partNo = row.partNo || '';
        this.setState({
            bomModalShow: true,
            bomModalLoading: true,
            bomModalError: '',
            bomModalRows: [],
            bomModalPartNo: partNo,
            bomModalMasterDataId: masterDataId,
            bomModalUoms: [],
        });

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        const bomUrl = `${config.apiUrl}/getBomList?master_data_id=${masterDataId}&limit=5000&offset=0`;
        const uomUrl = `${config.apiUrl}/getAllMaterialUom`;

        Promise.all([
            fetch(bomUrl, requestOptions).then((r) => r.text().then((t) => (t ? JSON.parse(t) : {}))),
            fetch(uomUrl, requestOptions).then((r) => r.text().then((t) => (t ? JSON.parse(t) : []))),
        ])
            .then(([bomBody, uoms]) => {
                const top = bomBody && bomBody.data ? bomBody.data : [];
                const rows = this.flattenBomTree(top);
                this.setState({
                    bomModalLoading: false,
                    bomModalRows: rows,
                    bomModalUoms: Array.isArray(uoms) ? uoms : [],
                });
            })
            .catch((err) => {
                console.error('Error loading BOM:', err);
                this.setState({
                    bomModalLoading: false,
                    bomModalError: 'Could not load BOM. Try opening the full BOM page.',
                });
            });
    };

    closeBomModal = () => {
        this.setState({
            bomModalShow: false,
            bomModalLoading: false,
            bomModalError: '',
            bomModalRows: [],
            bomModalPartNo: '',
            bomModalMasterDataId: null,
            bomModalUoms: [],
        });
    };

    buildHtmlTable() {
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            return fetch(`${config.apiUrl}/getMasterFinishedGoods?company=${user.accountId}&keyword=${this.state.keyword}&limit=${perPage}&offset=${this.state.offset}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(body => {
                    let array = [];
                    const products = [];

                    if (body && body.data) {
                        body.data.map((data, index) => {
                            array.push({
                                no: index + this.state.offset + 1,
                                id: data.id,
                                partNo: data.partNo || '',
                                partDescription: data.partDescription || '',
                                packagingType: data.packagingType || '',
                                packagingTypeOther: data.packagingTypeOther || '',
                                packagingQuantity: data.packagingQuantity || 0,
                                MOQ: data.MOQ || '',
                                UoM: data.UoM || '',
                                UoMOther: data.UoMOther || '',
                                shippingDock: data.shippingDock || '',
                                shippingDockOther: data.shippingDockOther || '',
                                incoterms: data.incoterms || '',
                                incotermsOther: data.incotermsOther || '',
                                customer: data.customer || '',
                                country: data.country || '',
                                countryOther: data.countryOther || '',
                                specialRequirement: data.specialRequirement || '',
                                sellingPrice: data.sellingPrice || 0,
                                sellingPriceCurrency: data.sellingPriceCurrency || 'MYR',
                                sellingPriceRate: data.sellingPriceRate || null,
                                shippingMode: data.shippingMode || '',
                                remarks: data.remarks || '',
                                photoUrl: data.photoUrl || '',
                                company: data.company || 0,
                                defaultLocationCode: data.defaultLocationCode || '',
                                bomMasterDataId: data.bomMasterDataId != null ? data.bomMasterDataId : null,
                                bomMaterialsSummary: data.bomMaterialsSummary || '',
                                isPartObsolete: data.isPartObsolete === true || data.isPartObsolete === 1 || data.isPartObsolete === '1'
                            });
                        });
                    }

                    this.setState({
                        products: array,
                        body: body.data || [],
                        pageCount: body.meta ? Math.ceil(body.meta.total_count / body.meta.limit) : 0,
                        loading: false
                    });
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    this.setState({ products: [], body: [], pageCount: 0, loading: false });
                });
        }
    }

    onClickProductSelected(cell, row, rowIndex) {
        const safeString = (val) => {
            if (val == null || val === undefined) return '';
            const str = String(val);
            return str === 'null' || str === 'undefined' ? '' : str;
        };
        const safeNumber = (val) => {
            if (val == null || val === undefined || val === '') return 0;
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        };

        this.setState({
            newMode: false,
            id: safeNumber(row.id),
            partNo: safeString(row.partNo),
            partDescription: safeString(row.partDescription),
            packagingType: safeString(row.packagingType),
            packagingTypeOther: safeString(row.packagingTypeOther),
            packagingQuantity: safeNumber(row.packagingQuantity),
            MOQ: safeString(row.MOQ),
            UoM: safeString(row.UoM),
            UoMOther: safeString(row.UoMOther),
            shippingDock: safeString(row.shippingDock),
            shippingDockOther: safeString(row.shippingDockOther),
            incoterms: safeString(row.incoterms),
            incotermsOther: safeString(row.incotermsOther),
            customer: safeString(row.customer),
            country: safeString(row.country),
            countryOther: safeString(row.countryOther),
            specialRequirement: safeString(row.specialRequirement),
            sellingPrice: safeNumber(row.sellingPrice),
            sellingPriceCurrency: safeString(row.sellingPriceCurrency || this.state.currencySettings.defaultCurrency || 'MYR'),
            sellingPriceRate: safeNumber(row.sellingPriceRate) || this.getCurrencyRate(safeString(row.sellingPriceCurrency || this.state.currencySettings.defaultCurrency || 'MYR'), this.state.currencySettings.currencies || []),
            shippingMode: safeString(row.shippingMode),
            remarks: safeString(row.remarks),
            photoUrl: safeString(row.photoUrl),
            photoPreview: safeString(row.photoUrl),
            defaultLocationCode: safeString(row.defaultLocationCode),
            selectedPhoto: null
        }, () => {
            setTimeout(() => {
                this.setState({ modalShow: true });
            }, 0);
        });
    }

    onDeleteProduct(cell, row, rowIndex) {
        fetch(`${config.apiUrl}/deleteMasterFinishedGoods`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: row.id,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    handlePageClick(data) {
        let selected = data.selected;
        let offset = Math.ceil(selected * perPage);
        this.setState({ offset: offset }, () => {
            this.buildHtmlTable();
        });
    }

    handlePhotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({
                selectedPhoto: file,
                photoPreview: URL.createObjectURL(file)
            });
        }
    }

    uploadPhoto = async () => {
        if (!this.state.selectedPhoto) {
            return this.state.photoUrl || '';
        }

        try {
            const response = await UploadFilesService.uploadImage([this.state.selectedPhoto]);

            // Handle multiple possible response structures from upload endpoint
            if (response && response.data) {
                // Case 1: data is array
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const fileData = response.data[0];
                    if (fileData.url) return fileData.url;
                    if (fileData.imgPath) return fileData.imgPath;
                    if (fileData.filename) return 'img/' + fileData.filename;
                    if (typeof fileData === 'string') return fileData;
                }

                // Case 2: data.files array
                if (Array.isArray(response.data.files) && response.data.files.length > 0) {
                    const fileData = response.data.files[0];
                    if (fileData.url) return fileData.url;
                    if (fileData.imgPath) return fileData.imgPath;
                    if (fileData.filename) return 'img/' + fileData.filename;
                    if (typeof fileData === 'string') return fileData;
                }

                // Case 3: data object direct fields
                if (response.data.url) return response.data.url;
                if (response.data.imgPath) return response.data.imgPath;
                if (response.data.filename) return 'img/' + response.data.filename;
                if (typeof response.data === 'string') return response.data;
            }

            console.warn('Unexpected upload response structure:', response);
            return '';
        } catch (error) {
            console.error('Error uploading photo:', error);
            return '';
        }
    }

    openPhotoInNewWindow = (url) => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    handlePartNoValidationChange = (partNoValidationStatus) => {
        this.setState({ partNoValidationStatus });
    };

    render() {
        const accessDenied = redirectUnlessInventory(localStorage.getItem('user'));
        if (accessDenied) return accessDenied;

        let { keyword, modalShow, newMode, products, locations, countries, body } = this.state;
        
        const safeString = (val) => (val !== undefined && val !== null) ? String(val) : '';
        const safeNumber = (val) => {
            if (val == null || val === undefined || val === '') return 0;
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        };

        const partNo = safeString(this.state.partNo);
        const partDescription = safeString(this.state.partDescription);
        const packagingType = safeString(this.state.packagingType);
        const packagingTypeOther = safeString(this.state.packagingTypeOther);
        const packagingQuantity = safeNumber(this.state.packagingQuantity);
        const MOQ = safeString(this.state.MOQ);
        const UoM = safeString(this.state.UoM);
        const UoMOther = safeString(this.state.UoMOther);
        const shippingDock = safeString(this.state.shippingDock);
        const shippingDockOther = safeString(this.state.shippingDockOther);
        const incoterms = safeString(this.state.incoterms);
        const incotermsOther = safeString(this.state.incotermsOther);
        const customer = safeString(this.state.customer);
        const country = safeString(this.state.country);
        const countryOther = safeString(this.state.countryOther);
        const specialRequirement = safeString(this.state.specialRequirement);
        const sellingPrice = safeNumber(this.state.sellingPrice);
        const totalSellingPrice = sellingPrice * packagingQuantity;
        const shippingMode = safeString(this.state.shippingMode);
        const remarks = safeString(this.state.remarks);
        const defaultLocationCode = safeString(this.state.defaultLocationCode);

        let handleClose = () => {
            this.setState({
                modalShow: false,
                id: 0,
                partNo: '',
                partDescription: '',
                packagingType: '',
                packagingTypeOther: '',
                packagingQuantity: 0,
                MOQ: '',
                UoM: '',
                UoMOther: '',
                shippingDock: '',
                shippingDockOther: '',
                incoterms: '',
                incotermsOther: '',
                customer: '',
                country: '',
                countryOther: '',
                specialRequirement: '',
                sellingPrice: 0,
                sellingPriceCurrency: this.state.currencySettings.defaultCurrency || 'MYR',
                sellingPriceRate: this.getCurrencyRate(this.state.currencySettings.defaultCurrency || 'MYR', this.state.currencySettings.currencies || []),
                editingRate: false,
                shippingMode: '',
                remarks: '',
                photoUrl: '',
                selectedPhoto: null,
                photoPreview: null,
                defaultLocationCode: '',
                partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE
            });
        };

        let handleSave = async () => {
            if (!window.confirm("Are you sure you want to update this data?")) return;

            let photoUrl = this.state.photoUrl;
            if (this.state.selectedPhoto) {
                photoUrl = await this.uploadPhoto();
            }

            fetch(`${config.apiUrl}/updateMasterFinishedGoods`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: this.state.id,
                    partNo,
                    partDescription,
                    packagingType,
                    packagingTypeOther,
                    packagingQuantity,
                    MOQ,
                    UoM,
                    UoMOther,
                    shippingDock,
                    shippingDockOther,
                    incoterms,
                    incotermsOther,
                    customer,
                    country,
                    countryOther,
                    specialRequirement,
                    sellingPrice,
                    sellingPriceCurrency: this.state.sellingPriceCurrency,
                    sellingPriceRate: this.state.sellingPriceRate,
                    shippingMode,
                    remarks,
                    photoUrl,
                    defaultLocationCode
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    }
                });
        }

        let handleCreate = async () => {
            let photoUrl = '';
            if (this.state.selectedPhoto) {
                photoUrl = await this.uploadPhoto();
            }

            const user = JSON.parse(localStorage.getItem('user'));
            fetch(`${config.apiUrl}/createMasterFinishedGoods`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    partNo,
                    partDescription,
                    packagingType,
                    packagingTypeOther,
                    packagingQuantity,
                    MOQ,
                    UoM,
                    UoMOther,
                    shippingDock,
                    shippingDockOther,
                    incoterms,
                    incotermsOther,
                    customer,
                    country,
                    countryOther,
                    specialRequirement,
                    sellingPrice,
                    sellingPriceCurrency: this.state.sellingPriceCurrency,
                    sellingPriceRate: this.state.sellingPriceRate,
                    shippingMode,
                    remarks,
                    photoUrl,
                    defaultLocationCode,
                    company: user.accountId
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false, newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    }
                });
        }

        return (
            <div className="container">
                <div style={{
                    marginBottom: '20px',
                    position: 'relative',
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineName">
                            <FormControl
                                type="text"
                                placeholder="Search..."
                                onChange={ev => { this.setState({ keyword: ev.target.value }) }}
                                value={keyword || ''}
                                style={{ minWidth: '200px' }}
                            />
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.buildHtmlTable()}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.exportExcel()}>Export</Button>
                        <Button
                            bsStyle="danger"
                            onClick={e => {
                                this.setState({
                                    id: 0,
                                    partNo: '',
                                    partDescription: '',
                                    packagingType: '',
                                    packagingTypeOther: '',
                                    packagingQuantity: 0,
                                    MOQ: '',
                                    UoM: '',
                                    UoMOther: '',
                                    shippingDock: '',
                                    shippingDockOther: '',
                                    incoterms: '',
                                    incotermsOther: '',
                                    customer: '',
                                    country: '',
                                    countryOther: '',
                                    specialRequirement: '',
                                    sellingPrice: 0,
                                    sellingPriceCurrency: this.state.currencySettings.defaultCurrency || 'USD',
                                    sellingPriceRate: this.getCurrencyRate(this.state.currencySettings.defaultCurrency || 'USD', this.state.currencySettings.currencies || []),
                                    editingRate: false,
                                    shippingMode: '',
                                    remarks: '',
                                    photoUrl: '',
                                    selectedPhoto: null,
                                    photoPreview: null,
                                    partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
                                    newMode: true,
                                    modalShow: true
                                });
                            }}>New</Button>
                    </div>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" className="container">
                    <SharedDataTable
                        columns={this.columns}
                        data={products || []}
                        progressPending={this.state.loading}
                        progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading finished goods" />}
                        pagination
                    />
                </div>
                <Modal
                    size="lg"
                    show={this.state.bomModalShow}
                    onHide={this.closeBomModal}
                    dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            BOM — Part {this.state.bomModalPartNo || ''}
                            {this.state.bomModalMasterDataId ? (
                                <span style={{ fontWeight: 'normal', fontSize: '14px', marginLeft: '8px', color: '#666' }}>
                                    (master data id: {this.state.bomModalMasterDataId})
                                </span>
                            ) : null}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '70vh', overflow: 'auto' }}>
                        {this.state.bomModalLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center' }}>Loading BOM…</div>
                        ) : this.state.bomModalError ? (
                            <div style={{ padding: '12px', color: '#a94442' }}>{this.state.bomModalError}</div>
                        ) : (this.state.bomModalRows || []).length === 0 ? (
                            <div style={{ padding: '12px', color: '#888' }}>No BOM lines for this part.</div>
                        ) : (
                            <table className="table table-bordered table-condensed" style={{ fontSize: '13px', marginBottom: 0 }}>
                                <thead>
                                    <tr>
                                        <th style={{ whiteSpace: 'nowrap' }}>#</th>
                                        <th>Material</th>
                                        <th>Description</th>
                                        <th>Code</th>
                                        <th>Color</th>
                                        <th style={{ textAlign: 'right' }}>Usage</th>
                                        <th>UoM</th>
                                        <th style={{ textAlign: 'right' }}>Per</th>
                                        <th>Where used</th>
                                        <th>Supplier</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.bomModalRows || []).map((r, i) => (
                                        <tr key={`${r.rowNo}-${i}`}>
                                            <td style={{ whiteSpace: 'nowrap' }}>{r.rowNo}</td>
                                            <td>{r.material}</td>
                                            <td>{r.materialDesc}</td>
                                            <td>{r.code}</td>
                                            <td>{r.color}</td>
                                            <td style={{ textAlign: 'right' }}>{r.usage != null ? r.usage : ''}</td>
                                            <td>{utils.mapTo(this.state.bomModalUoms || [], r.uom) || r.uom || ''}</td>
                                            <td style={{ textAlign: 'right' }}>{r.per != null ? r.per : ''}</td>
                                            <td>{r.where_use}</td>
                                            <td>{r.supplier}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.bomModalMasterDataId ? (
                            <a
                                className="btn btn-default"
                                href={`#/bomlist/${this.state.bomModalMasterDataId}`}
                                style={{ marginRight: '8px' }}
                            >
                                Open full BOM page
                            </a>
                        ) : null}
                        <Button onClick={this.closeBomModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
                {/* Hidden export table for Excel */}
                <div id="master-finished-goods-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '6px' }}>No</th>
                                <th style={{ padding: '6px' }}>Customer</th>
                                <th style={{ padding: '6px' }}>Country</th>
                                <th style={{ padding: '6px' }}>Country Other</th>
                                <th style={{ padding: '6px' }}>Part Number</th>
                                <th style={{ padding: '6px' }}>BOM link (master data id)</th>
                                <th style={{ padding: '6px' }}>BOM materials</th>
                                <th style={{ padding: '6px' }}>Part Description</th>
                                <th style={{ padding: '6px' }}>Packaging Type</th>
                                <th style={{ padding: '6px' }}>Packaging Type Other</th>
                                <th style={{ padding: '6px' }}>Packaging Quantity</th>
                                <th style={{ padding: '6px' }}>MOQ</th>
                                <th style={{ padding: '6px' }}>UoM</th>
                                <th style={{ padding: '6px' }}>UoM Other</th>
                                <th style={{ padding: '6px' }}>Default Location</th>
                                <th style={{ padding: '6px' }}>Shipping Dock</th>
                                <th style={{ padding: '6px' }}>Shipping Dock Other</th>
                                <th style={{ padding: '6px' }}>Incoterms</th>
                                <th style={{ padding: '6px' }}>Incoterms Other</th>
                                <th style={{ padding: '6px' }}>Special Requirement</th>
                                <th style={{ padding: '6px' }}>Selling Price (/pc)</th>
                                <th style={{ padding: '6px' }}>Selling Price Currency</th>
                                <th style={{ padding: '6px' }}>Selling Price Rate</th>
                                <th style={{ padding: '6px' }}>Shipping Mode</th>
                                <th style={{ padding: '6px' }}>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(body || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td style={{ padding: '4px' }}>{index + 1}</td>
                                    <td style={{ padding: '4px' }}>{item.customer || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.country || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.countryOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.bomMasterDataId != null ? String(item.bomMasterDataId) : ''}</td>
                                    <td style={{ padding: '4px' }}>{item.bomMaterialsSummary || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partDescription || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.packagingType || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.packagingTypeOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.packagingQuantity || 0}</td>
                                    <td style={{ padding: '4px' }}>{item.MOQ || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.UoM || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.UoMOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.defaultLocationCode || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.shippingDock || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.shippingDockOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.incoterms || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.incotermsOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.specialRequirement || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.sellingPrice || 0}</td>
                                    <td style={{ padding: '4px' }}>{item.sellingPriceCurrency || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.sellingPriceRate || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.shippingMode || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.remarks || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {modalShow && (
                    <Modal size="lg" show={modalShow} onHide={handleClose}
                        aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w"
                        key={`modal-${this.state.id || 'new'}`}>
                        <Modal.Header closeButton>
                            {newMode ? (<Modal.Title>New Master Finished Goods</Modal.Title>) : (<Modal.Title>Edit Master Finished Goods</Modal.Title>)}
                        </Modal.Header>
                        <Modal.Body style={INVENTORY_MODAL_BODY_SCROLL_STYLE} onFocusCapture={handleFocusInScrollField}>
                            <div>
                                <Form>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                                <Col sm={9}>
                                                    <MasterPartNoInput
                                                        value={partNo}
                                                        onChange={value => this.setState({ partNo: value })}
                                                        enabled={true}
                                                        onValidationChange={this.handlePartNoValidationChange}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part Description</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ partDescription: ev.target.value }) }} value={partDescription} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Packaging Type</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl as="select" value={packagingType} onChange={(e) => {
                                                        this.setState({ packagingType: e.target.value });
                                                    }}>
                                                        <option value="">Select</option>
                                                        <option value="carton">Carton</option>
                                                        <option value="pallet">Pallet</option>
                                                        <option value="box">Box</option>
                                                        <option value="others">Others</option>
                                                    </FormControl>
                                                    {packagingType === 'others' && (
                                                        <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ packagingTypeOther: ev.target.value }) }} value={packagingTypeOther} />
                                                    )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Packaging Quantity</Form.Label></Col>
                                                <Col sm={9}><FormControl type="number" min="0" onChange={ev => { this.setState({ packagingQuantity: Number(ev.target.value) || 0 }) }} value={packagingQuantity} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>MOQ</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ MOQ: ev.target.value }) }} value={MOQ} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>UoM</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl as="select" value={UoM} onChange={(e) => {
                                                        this.setState({ UoM: e.target.value });
                                                    }}>
                                                        <option value="">Select</option>
                                                        <option value="pcs">PCS</option>
                                                        <option value="kg">KG</option>
                                                        <option value="liter">Liter</option>
                                                        <option value="gram">Gram</option>
                                                        <option value="others">Others</option>
                                                    </FormControl>
                                                    {UoM === 'others' && (
                                                        <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ UoMOther: ev.target.value }) }} value={UoMOther} />
                                                    )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Default Location</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl
                                                    as="select"
                                                    value={defaultLocationCode}
                                                    onChange={e => this.setState({ defaultLocationCode: e.target.value })}
                                                >
                                                    <option value="">-- Select Location --</option>
                                                    {(locations || []).map(loc => (
                                                        <option key={loc.id} value={loc.locationCode}>
                                                            {loc.locationCode} - {loc.locationDescription}
                                                        </option>
                                                    ))}
                                                </FormControl>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Shipping Dock</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl as="select" value={shippingDock} onChange={(e) => {
                                                        this.setState({ shippingDock: e.target.value });
                                                    }}>
                                                        <option value="">Select</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="not applicable">Not Applicable</option>
                                                        <option value="others">Others</option>
                                                    </FormControl>
                                                    {shippingDock === 'others' && (
                                                        <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ shippingDockOther: ev.target.value }) }} value={shippingDockOther} />
                                                    )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Incoterms</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl as="select" value={incoterms} onChange={(e) => {
                                                        this.setState({ incoterms: e.target.value });
                                                    }}>
                                                        <option value="">Select</option>
                                                        <option value="CIP">CIP - Carriage and Insurance Paid to</option>
                                                        <option value="CPT">CPT - Carriage Paid to</option>
                                                        <option value="CFR">CFR - Cost and Freight</option>
                                                        <option value="CIF">CIF - Cost, Insurance, and Freight</option>
                                                        <option value="DAP">DAP - Delivered at Place</option>
                                                        <option value="DPU">DPU - Delivered at Place Unloaded</option>
                                                        <option value="DDP">DDP - Delivered Duty Paid</option>
                                                        <option value="EXW">EXW - Ex Works</option>
                                                        <option value="FAS">FAS - Free Alongside Ship</option>
                                                        <option value="FCA">FCA - Free Carrier</option>
                                                        <option value="FOB">FOB - Free on Board</option>
                                                        <option value="others">Others</option>
                                                    </FormControl>
                                                    {incoterms === 'others' && (
                                                        <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ incotermsOther: ev.target.value }) }} value={incotermsOther} />
                                                    )}
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Customer</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ customer: ev.target.value }) }} value={customer} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Country</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl as="select" value={country} onChange={(e) => {
                                                        this.setState({ country: e.target.value });
                                                    }}>
                                                        <option value="">Select</option>
                                                        {countries.map((countryName) => (
                                                            <option key={countryName} value={countryName}>{countryName}</option>
                                                        ))}
                                                    </FormControl>
                                                    {country === 'Others' && (
                                                        <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ countryOther: ev.target.value }) }} value={countryOther} />
                                                    )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Special Requirement</Form.Label></Col>
                                                <Col sm={9}><FormControl as="textarea" rows={3} onChange={ev => { this.setState({ specialRequirement: ev.target.value }) }} value={specialRequirement} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Selling Price (/pc)</Form.Label></Col>
                                                <Col sm={9}>
                                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                        <div style={{ flex: '1', minWidth: '150px' }}>
                                                            <FormControl 
                                                                type="number" 
                                                                step="0.01" 
                                                                min="0" 
                                                                onChange={ev => { this.setState({ sellingPrice: Number(ev.target.value) || 0 }) }} 
                                                                value={sellingPrice} 
                                                            />
                                                        </div>
                                                        <div style={{ minWidth: '100px' }}>
                                                            <FormControl
                                                                as="select"
                                                                value={this.state.sellingPriceCurrency}
                                                                onChange={(e) => {
                                                                    const selectedCurrency = e.target.value;
                                                                    // When switching currency, always update to the default rate from currency settings
                                                                    const defaultRate = this.getCurrencyRate(selectedCurrency, this.state.currencySettings.currencies || []);
                                                                    this.setState({ 
                                                                        sellingPriceCurrency: selectedCurrency,
                                                                        sellingPriceRate: defaultRate,
                                                                        editingRate: false
                                                                    });
                                                                }}
                                                            >
                                                                {this.state.currencySettings.currencies.map(currency => (
                                                                    <option key={currency.code} value={currency.code}>
                                                                        {currency.code}
                                                                    </option>
                                                                ))}
                                                            </FormControl>
                                                        </div>
                                                    </div>
                                                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                                        <div style={{ marginBottom: '5px' }}>
                                                            <strong>Total Price ({packagingQuantity || 0} pcs):</strong>{' '}
                                                            {totalSellingPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {this.state.sellingPriceCurrency || 'MYR'}
                                                        </div>
                                                        <div style={{ marginBottom: '5px' }}>
                                                            <strong>Exchange Rate:</strong>{' '}
                                                            {this.state.editingRate ? (
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                                                    <FormControl
                                                                        type="number"
                                                                        step="0.0001"
                                                                        min="0"
                                                                        value={this.state.sellingPriceRate}
                                                                        onChange={(e) => this.setState({ sellingPriceRate: parseFloat(e.target.value) || 0 })}
                                                                        style={{ width: '100px', display: 'inline-block' }}
                                                                        autoFocus
                                                                    />
                                                                    <Button
                                                                        variant="success"
                                                                        size="sm"
                                                                        onClick={() => this.setState({ editingRate: false })}
                                                                    >
                                                                        Save
                                                                    </Button>
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    {this.state.sellingPriceRate.toFixed(4)}
                                                                    <Button
                                                                        variant="link"
                                                                        size="sm"
                                                                        onClick={() => this.setState({ editingRate: true })}
                                                                        style={{ padding: '0 5px', fontSize: '12px' }}
                                                                    >
                                                                        (Edit)
                                                                    </Button>
                                                                </span>
                                                            )}
                                                        </div>
                                                        {this.state.currencySettings.defaultCurrency && 
                                                         this.state.sellingPriceCurrency !== this.state.currencySettings.defaultCurrency && (
                                                            <>
                                                            <div style={{ marginBottom: '5px' }}>
                                                                <strong>Converted to {this.state.currencySettings.defaultCurrency}:</strong>{' '}
                                                                {(() => {
                                                                    const fromRate = this.state.sellingPriceRate || this.getCurrencyRate(this.state.sellingPriceCurrency, this.state.currencySettings.currencies || []);
                                                                    const toRate = this.getCurrencyRate(this.state.currencySettings.defaultCurrency, this.state.currencySettings.currencies || []);
                                                                    if (fromRate === 0 || !sellingPrice) return '0.00';
                                                                    return ((sellingPrice * toRate) / fromRate).toFixed(2);
                                                                })()}
                                                            </div>
                                                            <div>
                                                                <strong>Total converted ({packagingQuantity || 0} pcs):</strong>{' '}
                                                                {(() => {
                                                                    const fromRate = this.state.sellingPriceRate || this.getCurrencyRate(this.state.sellingPriceCurrency, this.state.currencySettings.currencies || []);
                                                                    const toRate = this.getCurrencyRate(this.state.currencySettings.defaultCurrency, this.state.currencySettings.currencies || []);
                                                                    if (fromRate === 0) return '0.00';
                                                                    const convertedTotal = (totalSellingPrice * toRate) / fromRate;
                                                                    return convertedTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                                })()} {this.state.currencySettings.defaultCurrency}
                                                            </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Shipping Mode</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl as="select" value={shippingMode} onChange={(e) => {
                                                        this.setState({ shippingMode: e.target.value });
                                                    }}>
                                                        <option value="">Select</option>
                                                        <option value="Sea">Sea</option>
                                                        <option value="Air">Air</option>
                                                        <option value="Land">Land</option>
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Remarks</Form.Label></Col>
                                                <Col sm={9}><FormControl as="textarea" rows={3} onChange={ev => { this.setState({ remarks: ev.target.value }) }} value={remarks} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Upload Photo</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl type="file" accept="image/*" onChange={this.handlePhotoChange} />
                                                    <small className="text-muted" style={{ fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                                        Supported formats: JPG, PNG, GIF. Maximum file size: 5MB
                                                    </small>
                                                    {this.state.photoPreview && (
                                                        <div style={{ marginTop: '10px' }}>
                                                            <img src={this.state.photoPreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                                                            <div style={{ marginTop: '8px' }}>
                                                                <Button
                                                                    type="button"
                                                                    bsStyle="info"
                                                                    onClick={() => this.openPhotoInNewWindow(this.state.photoPreview)}
                                                                >
                                                                    Open
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {!this.state.photoPreview && this.state.photoUrl && (
                                                        <div style={{ marginTop: '10px' }}>
                                                            <img src={this.state.photoUrl} alt="Current" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                                                            <div style={{ marginTop: '8px' }}>
                                                                <Button
                                                                    type="button"
                                                                    bsStyle="info"
                                                                    onClick={() => this.openPhotoInNewWindow(this.state.photoUrl)}
                                                                >
                                                                    Open
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            {newMode && (<Button variant="primary" onClick={handleCreate} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Create
                            </Button>)}
                            {!newMode && (<Button variant="primary" onClick={handleSave} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Save Changes
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

export { MasterFinishedGoods };
